import { gql } from '@apollo/client';
import { Box, Typography } from '@mui/material';
import moment from 'moment';

import { VisitState, renderVisitState } from '../../types/visit';
import { formatTime } from '../../utils/datetimes/formatting';
import { ReturnComponent } from '../../utils/reactTypes';
import { VisitStateIcon } from '../visits/VisitStateIcon';
import { CommsItemType } from './types';

export const VisitStateChangeItemFragment = gql`
    fragment VisitStateChangeItem on VisitStateChange {
        createdAt
        state
    }
`;

export interface IVisitStateChangeItem {
    createdAt: Date;
    state: VisitState;
}

export function isVisitStateChangeItem(
    item: CommsItemType | IVisitStateChangeItem,
): item is IVisitStateChangeItem {
    return 'createdAt' in item;
}

export const CommsVisitStateChangeItem = ({
    stateChange: { createdAt, state },
    timezone,
}: {
    stateChange: IVisitStateChangeItem;
    timezone: string;
}): ReturnComponent => {
    const momentDate = moment(createdAt).tz(timezone);
    return (
        <Box display={'flex'} alignItems={'center'} justifyContent={'center'} gap={0.5}>
            <VisitStateIcon state={state} sx={{ fontSize: '1.25em' }} />
            <Typography fontSize={'inherit'}>
                Visit changed to <strong>{renderVisitState(state)}</strong>.{' '}
                {formatTime(momentDate, timezone, { hideTimezone: true })}
            </Typography>
        </Box>
    );
};
